import styled from 'styled-components'

const SurveyUi = styled.div`
  ${p => p.theme.phone} {
    ${({ mobileStyles = {} }) => mobileStyles}
  }
  ${({ styles = {} }) => styles}
`

export default SurveyUi
